// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/icon/index.css
// module id = 23
// module chunks = 32